import { render, staticRenderFns } from "./BlockFeedback.vue?vue&type=template&id=fc0ea14a&"
import script from "./BlockFeedback.vue?vue&type=script&lang=js&"
export * from "./BlockFeedback.vue?vue&type=script&lang=js&"
import style0 from "./BlockFeedback.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports